import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreloadImgComponent } from '../preload-img/preload-img.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-avatar-container',
  standalone: true,
  imports: [CommonModule, PreloadImgComponent],
  template: `<span class="d-flex flex-row align-items-center">
    @if(picture === null){
    <div class="avatar-container avatar" [style.background-color]="randomColor">
      {{ abrev }}
    </div>
    } @else{

    <commonui-preload-img
      [urlImg]="picture"
      [containerClass]="'rounded-circle shadow-sm '"
      [imageHeight]="28"
      [imageWidth]="28"
      [containerHeight]="28"
      [containerWidth]="28"
      class="me-2"
    >
    </commonui-preload-img>

    } @if(showName && name !== null){
    <span
      class="avatar-name d-flex"
      [ngClass]="{
      'flex-row': inline,
      'flex-column': !inline,
    }"
    >
      <div class="me-1">{{ name }}</div>
      <em class="text-body-secondary">{{ description }}</em></span
    >
    }
  </span>`,
  styles: [
    `
      .avatar-container {
        display: inline-block;
        vertical-align: middle;
      }
      .avatar {
        border-radius: 50%;
        width: 28px;
        min-width: 28px;
        height: 28px;
        line-height: 28px;
        font-size: 11px;
        text-align: center;
        color: azure;
      }

      .avatar-name {
        margin-left: 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarContainerComponent {
  @Input() picture: string | null = null;
  @Input() showName = true;
  @Input() description: string | null = null;
  @Input() inline = false;
  abrev: string | null = null;
  _name: string | null = null;
  randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

  @Input({ required: true }) set name(name: string | null) {
    this._name = name;
    this.abrev = name!
      .trim()
      .split(' ')
      .map((text) => text[0])
      .join('');
  }

  get name() {
    return this._name;
  }
}
